<template>
  <div>
    <van-button round size="small" type="info" @click="myCreated">创建</van-button>
    <div class="content" v-for="(item, index) in dataList" :key="index" @click="checked(item)">
      <div>
        <div class="left-tit">{{ item.title }}</div>
        <div :class="item.releaseFlag == 1 ? 'left-bot  left-bot1' : 'left-bot'">
          <span :class="item.releaseFlag == 1 ? 'left-dots1' : 'left-dots'"></span>
          <span class="left-span" >{{ item.releaseFlag == 1 ? '已发布' : '未发布' }}</span>
        </div>
      </div>
      <div class="right-sty">
        <div class="right-number">{{ item.total == null ? 0 : item.total }}</div>
        <div class="right-text">答卷数量</div>
      </div>
    </div>
    <van-share-sheet v-model="showShare" :options="options" @select="onSelected"/>
  </div>
</template>
<script>
import URL from '@/api/api'
import { Dialog } from 'vant';
export default {
  data() {
    return {
      id:'',
      dataList: [
        // {id:1, title: "白雪公主和七个小矮人", type: 0, number: 1 },
        // {id:2, title: "白雪公主和七个小矮人", type: 1, number: 1 },
        // {id:3, title: "白雪公主和七个小矮人", type: 0, number: 2 },
      ],
      showShare:false,
      options: [
        [{
          name: '删除',
          icon: require(`./../assets/img/delete.png`),
        },
        {
          name: '编辑',
          icon: require(`./../assets/img/edit.png`),
        },
        {
          name: '分享',
          icon: require(`./../assets/img/share.png`),
        },
        {
          name: '发布',
          icon: require(`./../assets/img/release1.png`),
        },],
        [{
          name: '详情',
          icon: require(`./../assets/img/mine6.png`),
        },]
      ],
      releaseFlag:'',
      total:''
    };
  },
  mounted() {
    this.getQaList();
  },
  methods: {
      checked(item){
      this.id=item.id
          if(item.id){
            this.showShare=true
          }
        this.releaseFlag=item.releaseFlag
        this.total=item.total
      },
      onSelected(option){
          this.showShare = false;
        if ('编辑' == option.name) {
          this.$router.push({path: '/editQuestionnaire/details', query:{typeId: this.id}});
        }
        if ('发布' == option.name) {
          this.changeReleaseFlag(this.id,1);
        }
        if ('删除' == option.name) {
          this.$fetchGet(URL.removeQuestionnaire.url, {typeId: this.id}).then(res => {
            if (res.data.code == 20000) {
              this.getQaList();
            }
          })
        }
        if ('分享' == option.name) {
          this.changeReleaseFlag(this.id,1);
          this.$router.push({path: '/shareQuestionnaire', query:{typeId: this.id}});
        }

        if ('详情' == option.name) {
          if (this.total == null || this.total == 0) {
            Dialog.confirm({
              message: '还未答题，是否要分享',
            })
              .then(() => {
                this.changeReleaseFlag(this.id,1);
                this.$router.push({path: '/shareQuestionnaire', query:{typeId: this.id}});
              })
              .catch(() => {
                // on cancel
              });
          }else{
            this.$router.push({path: '/questionnaireResult/details', query:{typeId: this.id}});
          }
        }
      },
      //获取问卷列表  参与答题的问卷 joinFlag 1  创建的问卷 joinFlag 0
      getQaList() {
        let data={
          openId:localStorage.getItem("openid"),
          joinFlag:0
        }
        this.$fetchPost(URL.qaList.url, data).then(res => {
          this.dataList = res.data.data

        })
      },
      changeReleaseFlag(typeId, flag) {
        this.$fetchGet(URL.changeReleaseFlag.url, {typeId: typeId, flag: flag}).then(res => {
          if (res.data.code == 20000) {
            this.getQaList();
          }
        })
      },
      myCreated(){
        this.$router.push('/newQuestionnaire')
      }
  },
};
</script>
<style scoped>
.van-button--round{
  width: 65px;
  margin-left: 10px;
  border-radius: 10px;
  background-color: #fc6e09;
  border: 1px solid #fc6e09;
}
.content {
  width: 95%;
  margin: 10px auto;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  line-height: 35px;
  background: #fff;
  border-radius: 5px;
}
.left-tit {
  font-size: 0.35rem;
  font-weight: 600;
  font-family: serif;
}
.left-bot {
  font-size: 0.2rem;
  display: flex;
  color: #909399;
}
.left-bot1 {
  color: #fc6e09;
}
.left-dots , .left-dots1{
  width: 5px;
  height: 5px;
  background: #909399;
  display: block;
  border-radius: 50%;
  margin: auto 5px auto 0;
}
.left-dots {
  background: #909399;
}
.left-dots1{
    background: #fc6e09;
}
.right-sty {
  padding-left: 15px;
  border-left: 1px solid #f2f3f5;
}
.right-number {
  font-size: 0.3rem;
  font-weight: bold;
  text-align: center;
  color: #fc6e09;
}
.right-text {
  font-size: 0.2rem;
  color: #909399;
}
</style>
